import * as PIXI from 'pixi.js'
import {ShockwaveFilter} from '@pixi/filter-shockwave';

class ImgFilter{
	constructor(elem,bgImgElem) {
		this.elem = elem;
		this.bgelem = bgImgElem;
		this.app = {}
		this.defWidth = window.innerWidth;
		this.defHeight = window.innerHeight;
		this.jacket = {};
		this.imgW = '';
		this.imgH = '';
		this.Ploader = PIXI.loader;
	}

	setStage(){
		/**
		 * pixi appの定義
		 */
		this.app = new PIXI.Application({
			width: this.defWidth,
			height: this.defHeight,
			antialias: true,
			transparent: false,
			view : document.getElementById(this.elem)
		});

		/**
		 * ステージ設定
		 */
		this.app.renderer.view.style.position = "fixed";
		this.app.renderer.view.style.display = "block";
		this.app.renderer.autoResize = true;
		this.app.renderer.resize(this.defWidth, this.defHeight);
	}

	setImg(){
		this.bgimg = $(this.bgelem).css('background-image').replace(/(url\(|\)|'|")/gi, '');
		let _that = this;

		this.Ploader
		.reset()
		.add(_that.bgimg)
		.load(_that.settingImgParam.bind(_that));

		this.setFilter();
	}

	setFilter(){
		this.Shockwave_Filter = new ShockwaveFilter();
		this.Shockwave_Filter.center.x = 0;
		this.Shockwave_Filter.center.y = 0;
		this.Shockwave_Filter.wavelength = 600;
		this.Shockwave_Filter.amplitube = 8;
		this.Shockwave_Filter.brightness = 1.1;
		this.Shockwave_Filter.radious = 1000;
	}

	settingImgParam(){

		this.img = new PIXI.Sprite(
			this.Ploader.resources[this.bgimg].texture
		);
		this.imgW = this.img.width;
		this.imgH = this.img.height;

		this.img.x = this.defWidth / 2;
		this.img.y = this.defHeight / 2;
		this.img.anchor.x = 0.5;
		this.img.anchor.y = 0.5;

		this.resizeImg(this.img,{
			baseWidth:this.imgW,
			baseHeight:this.imgH,
			windowWidth:this.defWidth,
			windowHeight:this.defHeight
		})

		this.app.stage.addChild(this.img);
		this.img.filters = [this.Shockwave_Filter];
	}

	resizeImg(obj,{baseWidth=100, baseHeight=100, windowWidth=100, windowHeight=100} = {}){
		obj.x = windowWidth / 2;
		obj.y = windowHeight / 2;

		if(windowWidth >= windowHeight){
			if(baseWidth > windowWidth) windowWidth = baseWidth;
			obj.width = windowWidth;
			obj.height = windowWidth * (baseHeight / baseWidth);
		}else{
			if(baseHeight > windowHeight) windowHeight = baseHeight;
			obj.height = windowHeight;
			obj.width = windowHeight * (baseWidth / baseHeight);
		}
	}

	onResize(){
		let _that = this;
		$(window).on('resize',function(){
			let defWidth = window.innerWidth;
			let defHeight = window.innerHeight;

			_that.resizeImg(_that.img,{
				baseWidth:_that.imgW,
				baseHeight:_that.imgH,
				windowWidth:defWidth,
				windowHeight:defHeight
			});
			_that.app.renderer.resize(defWidth,defHeight);
		});
	}

	render() {
		let _that = this;
		requestAnimationFrame(_that.render.bind(_that));
		this.app.render(_that.app.stage);

		this.Shockwave_Filter.time = (this.Shockwave_Filter.time >= 5 ) ? 0 : this.Shockwave_Filter.time + 0.005;
	}

	exec(){
		this.setStage();
		this.setImg();
		this.setFilter();
		this.render();
	}
}

module.exports = ImgFilter;
